import React from 'react';
import Button from 'app/shared/core/Button';
import IconInstantTour from 'images/icons/instant-tour-teal.svg';

interface BookTourNowButtonProps {
  onClick?: () => void;
}

const BookTourNowButton = React.forwardRef<HTMLButtonElement, BookTourNowButtonProps>(({ onClick }, ref) => {
  return (
    <Button
      ref={ref}
      onClick={onClick}
      btnType={'primary-outline'}
      rounded={false}
      full
      bold
      size={'lg'}
      iconGap="xs"
      icon={{ src: IconInstantTour, width: '22px', height: '20px', alt: '' }}
      data-testid="book-tour-now-button"
    >
      Book tour now
    </Button>
  );
});

BookTourNowButton.displayName = 'BookTourNowButton';

export default BookTourNowButton;
